import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import { Theme } from '@styles/theme'
import 'antd/dist/antd.less'
import '@styles/antdCustomize/index.less'
import '../tailwindCustomize/index.scss'
import tw from 'twin.macro'

const GlobalStyle = createGlobalStyle<{ theme: Theme }>`
  //${reset};

  #root{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 100px;
  }

  *,*::before,*::after {
    box-sizing: border-box;
    font-family: 'Pretendard';
  }

  *:focus{
    ${tw`focus:ring-0`}
  }

  html,
  body {
    width: 100%;
    height: 100%;
    position: relative;
  }

  body {
    font-size: 18px;
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${({ theme }) => theme.colors.background_color};
    color: ${({ theme }) => theme.colors.text_color};
    transition-property: background-color, color;
    transition-duration: .5s;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input:-webkit-autofill {
	    -webkit-box-shadow: 0 0 0 1000px white inset;
	    box-shadow: 0 0 0 1000px white inset;
  } 

  @font-face {
      font-family: 'Pretendard';
      src: local('※'), url('/fonts/PretendardRegular.woff') format('woff'),
      url('/fonts/PretendardRegular.woff') format('woff');
      font-style: normal;
  }
`

export default GlobalStyle
